import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Package } from "lucide-react";
import { products } from "@/mock";
import ProductImage from "@/components/ProductImage";

export default function BundleBanner({ onAdd }) {
  const bundleTotal = products.length * 24;
  const bundlePrice = 79;
  const savings = bundleTotal - bundlePrice;

  const addBundle = () => {
    products.forEach((p) => onAdd?.({ ...p, price: bundlePrice / products.length }));
  };

  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="relative overflow-hidden bg-[#0a0a0a] text-white grid md:grid-cols-2 items-center">
          {/* Left: 4-pack showcase */}
          <div className="relative min-h-[460px] md:h-[540px] flex items-center justify-center py-8">
            <div
              className="absolute inset-0"
              style={{
                background:
                  "radial-gradient(60% 55% at 50% 45%, rgba(198,13,13,0.22) 0%, rgba(10,10,10,0) 65%)",
              }}
            />
            <div className="relative grid grid-cols-2 gap-4 md:gap-6 w-[80%] max-w-[440px]">
              {products.map((p) => (
                <div key={p.id} className="flex flex-col items-center">
                  <div className="w-full aspect-square flex items-center justify-center">
                    <ProductImage
                      src={p.img}
                      alt={`${p.color} boxer brief`}
                      className="drop-shadow-[0_20px_25px_rgba(0,0,0,0.55)]"
                    />
                  </div>
                  <div className="mt-2 text-[9px] tracking-[0.24em] uppercase text-white/60">
                    {p.color}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: copy */}
          <div className="p-8 md:p-14">
            <div className="inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-[#ff2626] font-bold mb-4">
              <Package size={14} /> Welcome to the club
            </div>
            <h2 className="text-4xl md:text-5xl font-black leading-[1.02] tracking-tight">
              THE 4-PACK
              <br />
              <span className="text-[#ff2626]">STARTER BUNDLE</span>
            </h2>
            <p className="mt-4 text-white/70 max-w-md text-[14px] leading-relaxed">
              One of each color. Ships in a discreet gift-ready box. The full lineup at your best price.
            </p>
            <div className="mt-6 flex items-baseline gap-3">
              <span className="text-4xl font-black">${bundlePrice}</span>
              <span className="text-white/40 line-through text-lg">${bundleTotal}</span>
              <span className="bg-[#c60d0d] text-white text-[10px] tracking-[0.18em] font-black uppercase px-2 py-1">
                Save ${savings}
              </span>
            </div>
            <Button
              onClick={addBundle}
              className="mt-8 bg-white hover:bg-white/90 text-black rounded-none px-8 h-12 tracking-[0.16em] text-[13px] font-black uppercase"
            >
              Add Bundle to Cart <ArrowRight size={16} className="ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
